import {
  DEVTOOLS_CHEVRON_ICON,
  DEVTOOLS_GRID_ICON,
  DEVTOOLS_INVIEW_ICON,
  DEVTOOLS_MAIN_ICON,
  DEVTOOLS_OFFSETS_BADGE_ICON,
  DEVTOOLS_OFFSETS_ICON,
  DEVTOOLS_PROGRESS_ICON,
  DEVTOOLS_RULERS_ICON,
} from "./StringDevtoolsIcons";

export class StringDevIconRegistry {
  private static instance: StringDevIconRegistry | null = null;
  private readonly icons = new Map<string, string>();

  private constructor() {
    this.register("main", DEVTOOLS_MAIN_ICON);
    this.register("grid", DEVTOOLS_GRID_ICON);
    this.register("inview", DEVTOOLS_INVIEW_ICON);
    this.register("rulers", DEVTOOLS_RULERS_ICON);
    this.register("offsets", DEVTOOLS_OFFSETS_ICON);
    this.register("offsets-badge", DEVTOOLS_OFFSETS_BADGE_ICON);
    this.register("progress", DEVTOOLS_PROGRESS_ICON);
    this.register("chevron", DEVTOOLS_CHEVRON_ICON);
  }

  public static getInstance(): StringDevIconRegistry {
    if (!this.instance) {
      this.instance = new StringDevIconRegistry();
    }
    return this.instance;
  }

  public register(id: string, svg: string): void {
    this.icons.set(id, svg);
  }

  public get(id: string): string | null {
    return this.icons.get(id) ?? null;
  }

  public resolve(iconOrId: string): string {
    return this.icons.get(iconOrId) ?? iconOrId;
  }
}

export function resolveDevtoolsIcon(iconOrId: string): string {
  return StringDevIconRegistry.getInstance().resolve(iconOrId);
}
